export default __webpack_public_path__ + "static/media/dashboard.223b63c5.svg";